import appStore from 'store';
import api from './api';
import {
  REGISTER_FORM,
  USER_STATUS,
  BANK_AUTH_STATUS,
  ID_NO_STATUS,
  EMAIL_SECURITY_STATUS,
  PHONE_SECURITY_STATUS,
  GOOGLE_SECURITY_STATUS,
  USER_VALUNTEER_STATUS,
  USER_BLOCKING_STATUS,
  QUERY_TYPE,
  PAGINATION
} from './constants';

const store = {
  namespaced: true,
  state: {
    userList: [],
    totalCount: 0,
    otherData: {},
    pagination: PAGINATION,
    queryTypeList: QUERY_TYPE,
    queryType: QUERY_TYPE[0].value,
    queryValue: ""
  },
  getters: {
    userList: state => {
      return state.userList
    }
  },
  mutations: {
    setAssessList(state, payload) {

      const start = (payload.page - 1) * payload.size;
      const end = start + payload.size;

      state.userList = payload.userInviteDetails.slice(start, end);
      state.totalCount = payload.userInviteDetails.length;
      state.otherData = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setQueryType(state, payload) {
      state.queryType = payload;
    },
    setQueryValue(state, payload) {
      state.queryValue = payload;
    }
  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size });
      commit('setQueryType', query.queryType);
      api.getUserList(query).then(({ data }) => {
        console.log(data, '----111');
        commit('setAssessList', { ...data, ...{ page: query.page, size: query.size } });
      });
    },
    updateVolunteer({ commit }, data) { // eslint-disable-line
      return new Promise(resolve => {
        api.updateVolunteer(data).then(res => {
          resolve(res);
        });
      });
    },
    resetPassword({ commit }, data) {
      return new Promise(resolve => {
        api.resetPassword(data).then(res => {
          resolve(res)
        })
      })
    },
    resetGoogle({ commit }, data) {
      return new Promise(resolve => {
        api.resetGoogle(data).then(res => {
          resolve(res)
        })
      })
    },
    cleanLoginForbid({ commit }, data) {
      return new Promise(resolve => {
        api.cleanLoginForbid(data).then(res => {
          resolve(res)
        })
      })
    },
    updateBlocking({ commit }, data) { // eslint-disable-line
      return new Promise(resolve => {
        api.updateBlocking(data).then(res => {
          resolve(res);
        });
      });
    },
    alterTradeUserMsg({ commit }, data) {
      return new Promise(resolve => {
        api.alterTradeUserMsg(data).then(res => {
          resolve(res);
        });
      });
    }
  }
};

appStore.registerModule('assess', store);
